import { toast } from "react-toastify";

export const TOAST_TYPE = {
  INFO: 0,
  SUCCESS: 1,
  WARNING: 2,
  ERROR: 3,
};
export const TOAST_POSITION = {
  TOP_CENTER: 10,
  TOP_LEFT: 11,
  TOP_RIGHT: 12,
  BOTTOM_CENTER: 20,
  BOTTOM_LEFT: 21,
  BOTTOM_RIGHT: 22,
};

export const showErrorMessage = (message) => {
  showMessage({ message, type: TOAST_TYPE.ERROR });
};
export const showInfoMessage = (message) => {
  showMessage({ message, type: TOAST_TYPE.INFO });
};

export const showMessage = (properties) => {
  const { message, type } = properties;
  let pos = properties.position || TOAST_POSITION.TOP_LEFT;

  let position;
  switch (pos) {
    case TOAST_POSITION.TOP_CENTER:
      position = { position: toast.POSITION.TOP_CENTER };
      break;
    case TOAST_POSITION.TOP_LEFT:
      position = { position: toast.POSITION.TOP_LEFT };
      break;
    case TOAST_POSITION.BOTTOM_CENTER:
      position = { position: toast.POSITION.BOTTOM_CENTER };
      break;
    case TOAST_POSITION.BOTTOM_LEFT:
      position = { position: toast.POSITION.BOTTOM_LEFT };
      break;
    case TOAST_POSITION.BOTTOM_RIGHT:
      position = { position: toast.POSITION.BOTTOM_RIGHT };
      break;
    default:
      position = { position: toast.POSITION.TOP_LEFT };
      break;
  }

  toast.configure({
    autoClose: 8000,
    draggable: true,
    //etc you get the idea
  });

  if (!type) toast(message);
  else if (type === TOAST_TYPE.SUCCESS) toast.success(message, position);
  else if (type === TOAST_TYPE.ERROR) {
    toast.error(message, position);
  } else if (type === TOAST_TYPE.WARNING) toast.warn(message, position);
  else if (type === TOAST_TYPE.INFO) toast.info(message, position);
};

export const hideMessage = () => {};
